import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.618 18L14 11.236 17.382 18h-6.764zM4 16V9.899A5.006 5.006 0 0 0 9.898 4H16v6.764l-1.106-2.211c-.339-.678-1.449-.678-1.789 0L9.382 16H4zm15.894 2.553L18 14.764V3.5A1.5 1.5 0 0 0 16.5 2H8.974C8.06.793 6.627 0 5 0 2.243 0 0 2.243 0 5c0 1.627.793 3.061 2 3.975V16.5A1.5 1.5 0 0 0 3.5 18h4.882l-.277.553A1 1 0 0 0 9 20h10a.997.997 0 0 0 .894-1.447z"
});

var SvgIconsMajor = function SvgIconsMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgIconsMajor as S };
